import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'bodyanalytics-eyebrow',
  standalone: true,
  templateUrl: './eyebrow.component.html',
  styleUrls: ['./eyebrow.component.scss'],
})
export class EyebrowComponent {
  readonly variant = input<'default' | 'light' | 'muted'>('default');
}
